import { createReducer } from 'redux-act';
import { Url } from 'finhelper';
import LocalStorageHelper from '#app/helpers/Cache/LocalStorageHelper';

const getLanguageData = (): Record<string, unknown> => {
  const lang = localStorage.getItem(LocalStorageHelper.LANGUAGE);
  const url = Url.getCurrentUrl();

  if (url.includes('/ru/') || parseInt(lang ?? '') === 1 || lang === null) {
    return require('../translations/ru').default;
  } else if (url.includes('/en/')) {
    return require('../translations/en').default;
  }

  return require('../translations/en').default;
};

const data = getLanguageData();

export default createReducer<Record<string, unknown>>({}, data);
